module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b', [_vm._v("A Note on the Manuscript")])])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("My friend, Harrison Smith, a young lawyer of the city, has recently given me a second manuscript, purportedly by the individual Tarl Cabot. It was his desire that I bring this second document, as I did the first, to the attention of a publisher. This time, however, because of the numerous claims and inquiries generated by the first manuscript, "), _c('i', [_vm._v("Tarnsman of Gor")]), _vm._v(", pertaining to various matters ranging from further alleged documentation for the existence of the Counter-Earth to disputes concerning the authorship of the manuscript, I have prevailed upon Smith to write something in the way of a preface to this second account, making clear his own role in these matters and telling us a bit more about Tarl Cabot, whom I have never had the good fortune to meet in person.")])]), _vm._v(" "), _c('p', {
    staticClass: "p6"
  }, [_c('span', {
    staticClass: "sz"
  }, [_vm._v("John Norman")])]), _vm._v(" "), _c('p', {
    staticClass: "p4"
  }, [_c('span', {
    staticClass: "sz"
  }, [_c('b')])]), _vm._v(" "), _c('p', {
    staticClass: "p7"
  }, [_c('span', {
    staticClass: "sz"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-238f345f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section2.vue
// module id = 69
// module chunks = 0